module.exports = __webpack_public_path__ + "img/marketing-careers.0a3126e6.jpg";